import {Injectable} from '@angular/core';
import {Subject, Subscription} from 'rxjs';

/**
 * ONE BUTTON
 * A custom Events service just like Ionic 3 Events https://ionicframework.com/docs/v3/api/util/Events/ which got removed in Ionic 5.
 *
 * @author Shashank Agrawal
 */
@Injectable({
    providedIn: 'root'
})
export class Events {

    private channels: { [key: string]: Subject<any>; } = {};
    private sub_channels: {} = {};

    log()
    {
        console.log(Object.keys(this.channels).length)
    }

    /**
     * Subscribe to a topic and provide a single handler/observer.
     * @param topic The name of the topic to subscribe to.
     * @param observer The observer or callback function to listen when changes are published.
     * @param sub_topic The name of the sub_topic to subscribe to.
     *
     * @returns Subscription from which you can unsubscribe to release memory resources and to prevent memory leak.
     */
    subscribe(topic: string, observer: (_: any) => void, sub_topic=null): Subscription {
        if (!this.channels[topic]) {
            // You can also use ReplaySubject with one concequence
            this.channels[topic] = new Subject<any>();

            this.sub_channels[topic] = {}
        }

        if(sub_topic) { // sub_topic- avoid subscribe for all listeners;
            this.sub_channels[topic][sub_topic] = new Subject<any>();
            return this.sub_channels[topic][sub_topic].subscribe(observer);
        }

        return this.channels[topic].subscribe(observer);
    }

    /**
     * Publish some data to the subscribers of the given topic.
     * @param topic The name of the topic to emit data to.
     * @param data data in any format to pass on.
     */
    publish(topic: string, data?: any): void {
        const subject = this.channels[topic];
        if (!subject) {
            // Or you can create a new subject for future subscribers
            return;
        }

        subject.next(data);

        for(let sub in this.sub_channels[topic])
        {
            this.sub_channels[topic][sub].next(data);
        }
    }

    /**
     * When you are sure that you are done with the topic and the subscribers no longer needs to listen to a particular topic, you can
     * destroy the observable of the topic using this method.
     * @param topic The name of the topic to destroy.
     * @param sub_topic The name of the sub_topic to destroy.
     */
    unsubscribe(topic: string, sub_topic=null): null {
        const subject = this.channels[topic];
        if (!subject) {
            return;
        }

        if(sub_topic)
        {
            let sub_subject = this.sub_channels[topic][sub_topic];
            if(!sub_subject) return;
            sub_subject.complete();
            delete this.sub_channels[topic][sub_topic];
            
            if(Object.keys(this.sub_channels[topic]).length)
                return
        }

        subject.complete();
        delete this.channels[topic];
    }

    /**
     * When you are sure that you are done with the topic and the subscribers no longer needs to listen to a particular topic, you can
     * destroy the observable of the topic using this method.
     * @param topic The name of the topic to destroy.
     */
    destroy(topic: string): null {
        const subject = this.channels[topic];
        if (!subject) {
            return;
        }

        subject.complete();
        delete this.channels[topic];
    }
}